/* eslint-disable camelcase */

export default {
  action: {
    back: 'Back',
    cancel: 'Cancel',
    close: 'Close',
    collapseDetails: 'Less details',
    confirm: 'Confirm',
    confirmAndInvite: 'Confirm and Invite',
    continue: 'Continue',
    createAccount: 'Create an account',
    expandDetails: 'More details',
    invite: 'Invite',
    logout: 'Log out',
    no: 'No',
    openSwitchOrganisation: 'Select an organisation:',
    organisation: 'Organisation',
    resendEmail: 'Re-send Activation email',
    returnToHome: 'Go to the home page',
    settings: 'Profile',
    skip: 'Skip',
    yes: 'Yes'
  },
  activateUser: {
    button: 're-send activation email',
    emailSent: "We've sent a new email",
    linkLabel: 'take me to my account',
    message: "We've sent an email to %{email}",
    messageLink: 'I have already clicked the button, ',
    resendMessage: "I did'nt receive an email, ",
    subMessage: 'Please, click on confirmation link to activate your account.',
    title: 'Thanks for creating an account with OnceForAll'
  },
  address: {
    addressLine: 'Address',
    city: 'City',
    country: 'Country',
    region: 'Region',
    postCode: 'Postcode',
    title: 'Address'
  },
  bdr: {
    access: {
      confirm: 'Go to Bâtisseur de Relations',
      collector: {
        text1: '__sBâtisseur de Relations : A unique business platform to find your future projects__s',
        text2: '__sLooking for a new supplier for a specific project?__s',
        text3: 'Bâtisseur de Relations platform allows you to :',
        text4: '  - Publish projects and search for suppliers according to your criteria and needs.',
        text5: '  - Find pre-qualified suppliers.',
        text6: '  - Ensure compliance for all your operations.',
        text7: '__sSave time in sourcing and focus on your core business with Bâtisseur de Relations !__s',
        text8: 'By clicking on "%{confirm}", your user account and your companies on OnceForAll platform will be automatically synced.'
      },
      depositor: {
        text1: '__sBâtisseur de Relations : A unique business platform to find your future projects.__s',
        text2: '__sDo you want to develop your business?__s',
        text3: 'Bâtisseur de Relations platform allows you to :',
        text4: '  - Search and consult public tenders.',
        text5: '  - Receive projects from private contractors.',
        text6: '  - Be listed on the largest network of construction companies in France.',
        text7: '__sSave time searching for projects and win new contracts with Bâtisseur de Relations !__s',
        text8: 'By clicking on "%{confirm}", your user account and your companies on OnceForAll platform will be automatically synced.'
      }
    },
    discover: {
      collector: {
        dashboard: {
          text: "Find qualified suppliers for your future projects from France's largest construction network."
        },
        other: {
          text: "Find qualified suppliers for your future projects from France's largest construction network."
        }
      },
      confirm: 'Try now',
      depositor: {
        text: 'Find new public and private business opportunities on a single platform and grow your business!'
      },
      title: '__sBâtisseur de Relations :__s'
    },
    errorNoUserAndBdrService: {
      text1: 'An error occurred while creating your Marketplace profile. We apologize for the inconvenience.',
      text2: 'Please let us know at the following address : <a href="mailto:service.clients@onceforall.fr" title="mailto:service.clients@onceforall.fr">service.clients@onceforall.fr</a>.',
      text3: 'See you soon on our platform, The Once For All team'
    },
    errorNoBdrService: {
      text1: 'Your current offer does not allow you to access this service. We apologize for the inconvenience.',
      text2: '👉 <a href="/alg/organisation/subscription">See my offer</a>',
      text3: 'See you soon on our platform!'
    }
  },
  banette: {
    documentName: 'Document name',
    explanatoryTooltip: 'Documents that are uploaded in the « Documents folder » will be visible by all the organisations that are part of the project',
    noDocument: 'There is no document in your list.',
    pleaseAddDocument: 'Click on « + » to add generic document to your project.',
    requireCCRD: 'Require Attestation Décennale Nominative',
    requireCRSE: 'Require Charte RSE',
    uploadNewDocument: 'Upload a document',
    widgetTitle: 'Documents folder'
  },
  client: {
    accessCode: {
      additionalInformation: 'Additional information',
      clientOrgName: 'Client organisation name',
      generateButton: 'Generate access code',
      generateText: 'Generate access code',
      generateWarning: 'Only french clients can be invited.',
      responseToAccessCode: 'Response to a tender',
      tenderReference: 'Tender reference'
    },
    add: {
      button: 'Add a client',
      inviteSuccess: 'The organisation %{name} has been added to your clients list!',
      notice: 'You will share your documents with all invited clients.',
      title: 'Add a client'
    },
    documents: 'My documents for %{clientName}',
    invitations: {
      actions: {
        accept: 'Accept',
        decline: 'Decline',
        resend: 'Resend invitation',
        tooltip: 'You have to wait %{count} days to resend the invitation'
      },
      noSent: 'No invitation to show',
      received: 'Invitations received',
      sent: 'Invitations sent'
    },
    invite: {
      defaultMessage: "%{userName} from %{organisationName} invites you to register on the OnceForAll platform of Attestation Légale in order to facilitate management of your subcontractor certificates (business registration, health insurance, liability insurance, etc.).\nOnceForAll is an independent service provided by Attestation Légale for the construction sector. It helps to secure your business relations by assisting you to maintain a complete and up-to-date set of company-certification documents.\nAs their client, you will then have full and unlimited access to %{organisationName}'s online documents.",
      inviteSuccess: 'Once the invited user registers on OnceForAll and adds his organisation, that organisation will automatically be linked to yours as one of its clients.',
      title: 'Invite a client'
    },
    myClients: 'Clients',
    relationshipAccepted: 'The invitation from your client has been accepted!',
    relationshipAlreadyReplied: 'You have already replied to the invitation',
    relationshipRejected: 'The invitation from your client has been declined',
    search: {
      notFound: 'No client found'
    }
  },
  contact: {
    content: 'You wish to specify your request',
    creationSuccess: 'Your request has been taken into account',
    email: 'kontakt.de@onceforall.com',
    horary: {
      alg_fr: 'Open Monday to Thursday from 8:30 to 12:30 and from 13:30 to 18:00 and Friday from 8:30 to 12:30 and from 13:30 to 17:00',
      ofa_de: 'Open Monday to Friday from 9h to 17h',
      ofa_it: 'Open Monday to Thursday from 8:30 to 12:30 and from 13:30 to 18:00 and Friday from 8:30 to 12:30 and from 13:30 to 17:00'
    },
    phone: {
      alg_fr: '+33 4 72 38 32 58',
      ofa_de: '+49 30 397 160 82',
      ofa_it: '+39 02 3056 9038'
    },
    subtype: 'And more specifically',
    title: 'Contact us',
    type: 'Your request concerns',
    types: {
      FileClaim: 'File a Claim',
      IdeaSuggestion: 'Idea suggestion / User experience sharing',
      MyCustomers: 'My customers',
      MyDocuments: 'My documents',
      MyOffer: 'My offer',
      MyProjects: 'My projects',
      MyReferencesList: 'My construction references list',
      MyRole: 'My role',
      MySettings: 'My settings',
      MySuppliers: 'My subcontractors',
      MyTraining: 'My training'
    }
  },
  country: {
    ANDORRA: 'Andorra',
    AUSTRIA: 'Austria',
    BELGIUM: 'Belgium',
    BOLIVIA: 'Bolivia',
    BULGARIA: 'Bulgaria',
    CROATIA: 'Croatia',
    CZECH_REPUBLIC: 'Czech Republic',
    DENMARK: 'Denmark',
    ESTONIA: 'Estonia',
    FRANCE: 'France',
    GERMANY: 'Germany',
    GREECE: 'Greece',
    HUNGARY: 'Hungary',
    ICELAND: 'Iceland',
    INDIA: 'India',
    ITALY: 'Italy',
    IVORY_COAST: 'Ivory Coast',
    LATVIA: 'Latvia',
    LITHUANIA: 'Lithuania',
    LUXEMBOURG: 'Luxembourg',
    MAURITIUS: 'Mauritius',
    MEXICO: 'Mexico',
    MONACO: 'Monaco',
    NETHERLANDS: 'Netherlands',
    POLAND: 'Poland',
    PORTUGAL: 'Portugal',
    ROMANIA: 'Romania',
    SERBIA: 'Serbia',
    SLOVAKIA: 'Slovakia',
    SLOVENIA: 'Slovenia',
    SPAIN: 'Spain',
    SWEDEN: 'Sweden',
    SWITZERLAND: 'Switzerland',
    UNITED_KINGDOM: 'United Kingdom',
    flags: {
      AD: 'Andorra',
      AT: 'Austria',
      BE: 'Belgium',
      BG: 'Bulgaria',
      BO: 'Bolivia',
      CH: 'Switzerland',
      CI: 'Ivory Coast',
      CZ: 'Czech Republic',
      DE: 'Germany',
      DK: 'Denmark',
      EE: 'Estonia',
      ES: 'Spain',
      FR: 'France',
      GB: 'United Kingdom',
      GR: 'Greece',
      HR: 'Croatia',
      HU: 'Hungary',
      IN: 'India',
      INTERNATIONAL: 'International',
      IS: 'Iceland',
      IT: 'Italy',
      LT: 'Lithuania',
      LU: 'Luxembourg',
      LV: 'Latvia',
      MC: 'Monaco',
      MU: 'Mauritius',
      MX: 'Mexico',
      NL: 'Netherlands',
      PL: 'Poland',
      PT: 'Portugal',
      RO: 'Romania',
      RS: 'Serbia',
      SE: 'Sweden',
      SI: 'Slovenia',
      SK: 'Slovakia'
    }
  },
  dashboard: {
    deactivated: {
      action: 'Contact us',
      message: 'Please contact us if you want to reactivate your organisation and renew your subscription.',
      title: 'Your organisation has been deactivated'
    },
    documents: 'Documents',
    documentsToProcess: {
      action: {
        sign: 'Sign this document',
        upload: 'Upload this document'
      },
      emptyList: 'All your documents have been processed',
      expandList: 'See all documents to process',
      message: {
        AWAITING_SIGNATURE: 'has to be signed',
        EXPIRED: 'is expired since %{expirationDate}',
        MISSING: 'is missing',
        REJECTED: 'was rejected for the following reason:'
      },
      title: 'Documents to process'
    },
    empty: {
      message: 'You have reviewed all your notifications',
      title: 'Well done!'
    },
    stats: {
      clients: 'Clients',
      link: {
        clients: 'See all clients',
        projects: 'See all projects',
        subcontractors: 'See all subcontractors',
        users: 'See all users'
      },
      projects: 'Projects',
      subcontractors: {
        nationality: {
          FRANCE: 'french',
          GERMANY: 'german',
          ITALY: 'italian'
        },
        title: 'Subcontractors',
        valid: "of this organisation's subcontractors have a valid %{nationality} dossier overview"
      },
      users: 'Users'
    }
  },
  datetime: {
    datePickerMask: [
      'd',
      'd',
      '/',
      'd',
      'd',
      '/',
      'd',
      'd',
      'd',
      'd'
    ],
    shortDate: 'DD/MM/YYYY',
    shortDatetime: 'DD/MM/YYYY HH:mm',
    undefined: '-'
  },
  document: {
    addAdditionalDesignation: 'Add additional designation',
    additionalDesignation: 'Additional designation',
    additionalDesignationNotice: 'Used to differentiate two documents of the same type',
    additionalDesignationSuccessUpdate: 'Additional designation has been successfully updated',
    all: 'All documents',
    canNotDownload: 'This document cannot be downloaded.',
    changeFile: 'Change file',
    chart: {
      almostExpired: 'documents almost expired',
      almostExpired_1: 'document almost expired',
      awaiting: 'documents in progress',
      awaiting_1: 'document in progress',
      percentageLabel: 'Valid',
      seeMyDocuments: 'See my documents',
      title: 'State of my documents',
      todo: 'documents to do',
      todo_1: 'document to do',
      valid: 'documents valid',
      valid_1: 'document valid'
    },
    checkFile: 'Verify document',
    chooseOnComputer: 'Choose on your computer',
    collectionMandateEnabled: {
      FRANCE: 'Collected by Attestation Légale',
      GERMANY: 'Collected by OnceForAll'
    },
    consultMyArchivedDocuments: 'Consult my archives',
    consultMyDocuments: 'Go back to documents',
    delete: 'Delete',
    documentDetails: {
      addNewVersion: 'Add a new version',
      documentExample: 'click to see an example',
      documentIsGathered: {
        FRANCE: 'This document is gathered by Attestation Légale.',
        GERMANY: 'This document is gathered by OnceForAll.'
      },
      documentIsRejected: 'The document has been rejected, click here to see more details.',
      documentVersionIsAwaitingSignature: 'A version of this document is awaiting a signature, click here to see more details.',
      documentVersionIsRejected: 'A version of this document has been rejected, click here to see more details.',
      emptyTimeline: 'This document does not have a valid version yet',
      noPastDocument: 'No archive for this document',
      noPresentDocument: 'No ongoing document version',
      noPresentDocumentAtDate: 'No valid version at the project opening date: %{projectOpeningDate}',
      noPresentDocumentAtInterventionDate: 'No valid version at the project intervention start date: %{interventionDate}',
      noPresentDocumentAtInterventionDateTooltip: 'The status is calculated on the project intervention start date because this organisation has been created after the project opening date.',
      showArchives: 'Show archives of this document',
      showTimelineButton: 'See all valid versions',
      state: {
        ALMOST_EXPIRED: 'Valid, expire %{time}',
        AWAITING_COMPLETION: 'Awaiting completion',
        AWAITING_GATHERING: 'Awaiting gathering',
        AWAITING_SIGNATURE: 'Awaiting signature',
        AWAITING_VALIDATION: 'Awaiting validation',
        CREATED: 'Unknown',
        EXPIRED: 'Expired %{time}',
        MISSING: 'Missing',
        NOT_APPLICABLE: 'Not applicable',
        REJECTED: 'Rejected',
        SIGNED: 'Signed, valid%{until}',
        VALID: 'Valid%{until}'
      },
      timeline: 'Timeline of document versions',
      unpublished: 'Archived document',
      validityEndLineForValid: ' until %{validityEnd}'
    },
    documentType: 'Document type',
    documentVersion: {
      ongoingLabel: 'Ongoing',
      rejectionReason: ' Reason: <span class="error">%{rejectionReason}</span>',
      state: {
        ALMOST_EXPIRED: '<strong class="success">valid</strong>',
        AWAITING_GATHERING: '<strong class="ofa">awaiting gathering</strong>',
        AWAITING_SIGNATURE: '<strong class="error">awaiting signature</strong>',
        AWAITING_VALIDATION: '<strong class="ofa">awaiting validation</strong>',
        EXPIRED: '<strong class="success">valid</strong>',
        MISSING: '<strong class="error">missing</strong>',
        NOT_APPLICABLE: '<strong class="information">not applicable</strong>',
        REJECTED: '<strong class="error">rejected</strong>.',
        SIGNED: '<strong class="success">signed and validated</strong>',
        VALID: '<strong class="success">valid</strong>'
      },
      stateLine: {
        CURRENT: 'This version of the document is %{state}',
        FUTURE: 'This version of the document will be %{state}',
        PAST: 'This version of the document was %{state}'
      },
      validityEndLine: ' until <strong>%{validityEnd}</strong>',
      validityFullLine: ' between <strong>%{validityStart}</strong> and <strong>%{validityEnd}</strong>',
      validityStartLine: ' from <strong>%{validityStart}</strong>'
    },
    dossierResume: {
      documentAlmostExpiredText: 'The following document will soon expire:',
      documentInvalidInProgressText: 'A document is currently in verification by OnceForAll.',
      documentInvalidText: 'You must process the following document: ',
      documentsAlmostExpiredText: 'The following documents will soon expire:',
      documentsInvalidsInProgressText: 'Documents are currently in verification by OnceForAll.',
      documentsInvalidsText: 'You must process the following documents: ',
      download: 'Download dossier overview',
      title: {
        AWAITING_VERIFICATION: 'Dossier awaiting verification',
        INVALID: 'Your dossier overview is invalid',
        VALID: 'Your dossier overview is valid',
        WARNING: 'Your dossier overview is valid, but will soon expire'
      }
    },
    downloadExcelTemplate: 'Download Excel template',
    downloadExcelTemplateMessage: 'First, download the Excel template',
    downloadTemplate: 'Download template',
    downloadTemplateMessage: 'First, download the template',
    dragDropHere: 'Drag and drop here',
    duplicate: 'Duplicate',
    editAdditionalDesignation: 'Edit additional designation',
    errorMaxSizeMessage: 'Maximum size is %{count}MB',
    errorMinSizeMessage: 'Minimum size is %{count}KB',
    errorTypeMessage: 'The file must be in the following format(s): ',
    fileSize: 'File size',
    filename: 'File name',
    foreignEmployees: {
      secondaryUploadMessage: 'Available formats: Excel and PDF (If you upload a PDF document, OnceForAll team will convert this list of employees into the Excel file and will then upload it for you.)',
      uploadMessage: {
        bullet1: 'Employees of the European Economic Area',
        bullet2: 'Temporary staff',
        line1: 'Are not concerned:',
        line2: 'The information provided will be verified by OnceForAll team.\nPlease make sure the information you provide is correct and clear enough.'
      }
    },
    header: {
      dossiers: 'Dossiers',
      name: 'Name',
      reminderStatus: 'Reminded status',
      status: 'Status',
      validityPeriod: 'Period of validity'
    },
    issueDate: 'Issue date',
    myArchivedDocuments: 'Archives',
    myDocuments: 'Documents',
    myTodoDocuments: 'To Do',
    noArchive: 'No archive',
    noDocumentMessage: 'In order to upload your documents, please add a client.',
    noForeignWorkers: "I don't have any foreign workers",
    noResultMatch: 'No result is matching your search',
    noSignPermission: 'Only the Legal Representative of this organisation can sign this document.',
    noTodo: 'You have no document to upload',
    notDepositor: 'Please contact the customer service to activate the depositor service on this organisation.',
    open: 'Download',
    openExcel: 'Download Excel file',
    openProof: 'Download authentication',
    payrollRatio: {
      NC: 'Not provided',
      label: 'Payroll ratio:'
    },
    planUpgradable: 'Your current offer needs to be upgraded to upload documents and invite clients.',
    remind: {
      additionalContext: 'Please specify the context of your reminder',
      command: {
        title: 'Remind the dossier'
      },
      context: 'Context',
      description: {
        additionalContext: 'Additional context:',
        dateFrom: 'Reminder dated on %{date}',
        emptyMessage: 'No reminder to show',
        projectName: 'Project name:',
        reason: {
          APPLICATION_APPROVAL: 'Application for approval',
          CONTRACT: 'Contract',
          CREATION_ADDITIONAL_DOCUMENT: 'Creation of additionnal document',
          END_OF_PROJECT: 'End of project',
          PAYMENT: 'Payment',
          PRIVATE_MARKET: 'Private market',
          PUBLIC_MARKET: 'Public market',
          REPORT_ANOMALY: 'Report an anomaly',
          SIGNATURE: 'Signature',
          title: 'Reason:'
        }
      },
      documents: {
        error: 'You have to select a document',
        title: 'Documents to remind'
      },
      information: "If your subcontractor's dossier is still incomplete despite the preventive reminders done by Attestation Légale, this service will trigger a formal call to your provider based on the context that you provide below.<br/><br/>We will keep you personally informed about the follow up of this request.",
      reason: {
        APPLICATION_APPROVAL: 'get an approval',
        CONTRACT: 'keep the dossier up-to-date',
        CREATION_ADDITIONAL_DOCUMENT: 'add an additional document in the dossier',
        PAYMENT: 'pay the bill',
        REPORT_ANOMALY: 'correct an error on a document',
        SIGNATURE: 'sign a contract',
        name: 'Reason'
      },
      subMessageProject: 'For the project',
      subMessageReason: 'I wish an update of its dossier to',
      success: 'The Document Reminder has been taken into account. You will receive a copy of the email.',
      title: 'Request for Specific Document Reminder'
    },
    searchArchiveBar: 'Archive name',
    searchBar: 'Document name',
    seeExample: 'See example',
    sign: 'Sign',
    signWaitingText: 'Please wait, you will be redirected to our electronic signature provider...',
    staff: 'Employees:',
    state: {
      ALMOST_EXPIRED: 'Almost expired',
      AWAITING_COMPLETION: 'Waiting for completion',
      AWAITING_GATHERING: 'Waiting for gathering',
      AWAITING_SIGNATURE: 'Waiting for signature',
      AWAITING_VALIDATION: 'Waiting for validation',
      CREATED: 'Unknown',
      EXPIRED: 'Expired',
      MISSING: 'Missing',
      NOT_APPLICABLE: 'Not applicable',
      REJECTED: 'Rejected',
      SIGNED: 'Signed',
      VALID: 'Valid'
    },
    upload: 'Upload',
    uploadMessage: {
      FRANCE: 'If your document is not in __sfrench__s, then you have to upload a file containing original file and its __stranslation__s.',
      GERMANY: 'If your document is not in __sgerman__s, then you have to upload a file containing original file and its __stranslation__s.'
    },
    uploadSuccess: 'The upload is successfully completed.',
    uploadUpdate: 'Update',
    valid: 'Valid',
    validityPeriod: 'From %{startDate} to %{endDate}',
    waiting: 'Waiting depositor action'
  },
  documentType: {
    search: {
      alreadyRequired: 'This document is already required for that project',
      notfound: 'This document type does not exist',
      placeholder: 'Search for a document'
    }
  },
  dossier: {
    add: 'Add a document',
    addLabel: 'Select a document',
    addSuccessful: 'The document is successfully added',
    countryLabel: 'Dossier ',
    download: {
      all: 'Download dossier',
      dossierOverview: 'Download dossier overview',
      standard: 'Download standard dossier',
      standardArchives: 'Download all archives'
    },
    interoperated: 'Interoperated dossier',
    labels: {
      ADDITIONAL: 'Additional',
      BUSINESS: {
        ALL: 'Business',
        CLEANING: 'Cleaning',
        CONSTRUCTION: 'Construction',
        SAFETY: 'Safety',
        TEMPORARY_WORK: 'Temporary work',
        TRANSPORTATION: 'Transportation'
      },
      LEGAL: 'Legal',
      PROJECT: 'Projects'
    },
    print: {
      all: 'Print dossier',
      standard: 'Print standard dossier'
    },
    projects: 'Projects',
    relatedProjects: 'Related projects',
    state: {
      AWAITING_VERIFICATION: {
        fullLabel: 'Dossier awaiting verification',
        shortLabel: 'Awaiting verification'
      },
      DEPOSITOR_SERVICE_DEACTIVATED: {
        fullLabel: 'Depositor service deactivated',
        shortLabel: 'Depositor service deactivated'
      },
      EMPTY: {
        fullLabel: 'No document for the selected country',
        shortLabel: 'No document for the selected country'
      },
      INVALID: {
        fullLabel: 'Incomplete dossier',
        shortLabel: 'Invalid'
      },
      UNKNOWN: {
        fullLabel: 'Dossier state is not available yet',
        shortLabel: 'Not available'
      },
      VALID: {
        fullLabel: 'Valid dossier',
        shortLabel: 'Valid'
      },
      WARNING: {
        fullLabel: 'Almost expired dossier',
        shortLabel: 'Soon invalid'
      },
      title: 'Dossier Status'
    }
  },
  error: {
    CGURequired: 'Terms and conditions must be accepted',
    clientAlreadyExists: 'Impossible to add more than 1 client, please correct the selection',
    dateShouldBeBefore: 'There is an intervention start date set prior to the new project opening date!',
    emailConfirmation: "Email confirmation doesn't match",
    generic: 'An error has occurred',
    interventionAlreadyEnded: 'You are already linked to this organisation in this project',
    invalidEmailFormat: 'Your email address format is not valid, please correct',
    invalidIdentificationNumber: 'Invalid identification number',
    invalidMobilePhoneNumber: 'Your mobile phone number format is not valid, please correct it',
    invalidNumberFormat: 'This field must contain numbers',
    invalidPhoneNumber: 'Your phone number format is not valid, please correct',
    invalidRegistrationNumber: 'Invalid registration number',
    notYetSupported: 'Not Yet Supported',
    organisationAlreadyExists: 'You are already linked to this organisation in this project',
    organisationNotFound: 'No organisation exists with this registration number',
    passwordConfirmation: "Password confirmation doesn't match",
    privacyPolicyRequired: 'The privacy policy must be accepted',
    required: 'This field is required',
    userAlreadyExist: 'An account already exists with this email',
    validation: 'This field value is invalid'
  },
  errorPage: {
    contactEmail: 'service.clients@onceforall.com',
    buttonLabel: 'Refresh page',
    subtitle: 'Sorry, something went wrong on our end. We are currently trying to fix the problem.',
    text: 'If the problem persists, you can contact us at ',
    title: 'ERROR'
  },
  favoriteRelationship: {
    add: 'Add to favorites',
    message: {
      add: '%{organisationName} has been added to favorites',
      remove: '%{organisationName} has been removed from favorites'
    },
    remove: 'Remove from favorites'
  },
  globalDashboard: {
    documents: 'Documents of my subcontractors',
    documentsStillValid: 'still valid',
    myOrganisations: 'My organisations',
    mySubcontractors: 'My subcontractors',
    organisationRegistrationSuccessful: {
      line1: 'Your request is now in process.',
      line2: 'You will be notified via email once the processing of your request has been completed.'
    },
    quitus: 'Dossier overviews of my subcontractors',
    quitusDescription: 'of my subcontractors have a valid dossier overview',
    seeAllSubcontractors: 'See all my active subcontractors',
    subcontractorsLabel: 'Active subcontractors'
  },
  globalSubcontractor: {
    noSubcontractors: 'No subcontractors',
    selectClientForSubcontractor: 'All your organisations with subcontractor %{subcontractorName}:',
    title: 'All my subcontractors'
  },
  helpCenter: {
    aQuestion: 'Any questions?',
    category: {
      ACCESS: 'My access',
      CLIENT: 'My clients',
      DOCUMENT: 'My documents',
      MODEL: 'My templates',
      OPTION: 'My options',
      PARAMETER: 'My settings',
      PROJECT: 'My projects',
      SUBCONTRACTOR: 'My subcontractors'
    },
    contactCustomerService: "Couldn't find your answer? Please",
    contactCustomerServiceLink: 'contact customer service',
    helpCenterButton: 'Open help and contact',
    selectACategory: 'Select a category:',
    title: 'Help center'
  },
  identificationNumber: {
    ANDORRA: {
      REGISTRATION_NUMBER: {
        name: 'TVA intracommunautaire',
        tooltip: 'FR + 11-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'TVA intracommunautaire (VAT Number)',
        tooltip: 'FR + 11-digit code'
      }
    },
    AUSTRIA: {
      REGISTRATION_NUMBER: {
        name: 'Umsatzsteuer-Identifikationsnummer',
        tooltip: 'ATU + 8-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Umsatzsteuer-Identifikationsnummer (VAT Number)',
        tooltip: 'ATU + 8-digit code'
      }
    },
    BELGIUM: {
      REGISTRATION_NUMBER: {
        name: 'BTW identificatienummer / Numéro de TVA',
        tooltip: 'BE + 10-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'BTW identificatienummer / Numéro de TVA (VAT Number)',
        tooltip: 'BE + 10-digit code'
      }
    },
    BOLIVIA: {
      REGISTRATION_NUMBER: {
        name: 'Número de Identificación Tributaria',
        tooltip: '8 to 12-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Número de Identificación Tributaria (VAT Number)',
        tooltip: '8 to 12-digit code'
      }
    },
    BULGARIA: {
      REGISTRATION_NUMBER: {
        name: 'Identifikacionen nomer po DDS',
        tooltip: 'BG + 9 or 10-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Identifikacionen nomer po DDS (VAT Number)',
        tooltip: 'BG + 9 or 10-digit code'
      }
    },
    CROATIA: {
      REGISTRATION_NUMBER: {
        name: 'PDV Id. Broj OIB',
        tooltip: 'HR + 11-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'PDV Id. Broj OIB (VAT Number)',
        tooltip: 'HR + 11-digit code'
      }
    },
    CZECH_REPUBLIC: {
      REGISTRATION_NUMBER: {
        name: 'Daňové identifikační číslo',
        tooltip: 'CZ + 8 to 10-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Daňové identifikační číslo (VAT Number)',
        tooltip: 'CZ + 8 to 10-digit code'
      }
    },
    DENMARK: {
      REGISTRATION_NUMBER: {
        name: 'Momsregistreringsnummer',
        tooltip: 'DK + 8-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Momsregistreringsnummer (TVA Number)',
        tooltip: 'DK + 8-digit code'
      }
    },
    ESTONIA: {
      REGISTRATION_NUMBER: {
        name: 'Käibemaksukohustuslase number',
        tooltip: 'EE + 9-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Käibemaksukohustuslase number (VAT Number)',
        tooltip: 'EE + 9-digit code'
      }
    },
    FRANCE: {
      GROUP_NUMBER: {
        name: 'SIREN',
        tooltip: '9-digit code'
      },
      REGISTRATION_NUMBER: {
        name: 'SIRET',
        tooltip: '14-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'TVA intracommunautaire (VAT Number)',
        tooltip: 'FR + 11-digit code'
      }
    },
    GERMANY: {
      REGISTRATION_NUMBER: {
        name: 'Betriebsnummer',
        tooltip: '8-digit code'
      },
      STEUERLICHE_IDENTIFIKATIONSNUMMER: {
        name: 'Steuerliche Identifikationsnummer',
        shortName: 'Steuernummer',
        tooltip: '11-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Umsatzsteuer-Identifikationsnummer (VAT Number)',
        shortName: 'Ust.-ID',
        tooltip: 'DE + 9-digit code'
      }
    },
    GREECE: {
      REGISTRATION_NUMBER: {
        name: 'Arithmós Forologikou Mētrṓou',
        tooltip: 'EL + 9-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Arithmós Forologikou Mētrṓou (VAT Number)',
        tooltip: 'EL + 9-digit code'
      }
    },
    HUNGARY: {
      REGISTRATION_NUMBER: {
        name: 'Közösségi adószám',
        tooltip: 'HU + 8-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Közösségi adószám (VAT Number)',
        tooltip: 'HU + 8-digit code'
      }
    },
    ICELAND: {
      REGISTRATION_NUMBER: {
        name: 'Virðisaukaskattsnúmer',
        tooltip: 'IS + 6-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Virðisaukaskattsnúmer (VAT Number)',
        tooltip: 'IS + 6-digit code'
      }
    },
    INDIA: {
      REGISTRATION_NUMBER: {
        name: 'Value Added Tax / Central Sales Tax TIN',
        tooltip: 'IN + 11-digit code + V'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Value Added Tax / Central Sales Tax TIN',
        tooltip: 'IN + 11-digit code + V'
      }
    },
    ITALY: {
      REGISTRATION_NUMBER: {
        name: 'Codice Fiscale',
        tooltip: '11-digit number for companies or 16-digit code for individuals'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Partita IVA (VAT Number)',
        tooltip: 'IT + 11-digit code'
      }
    },
    IVORY_COAST: {
      REGISTRATION_NUMBER: {
        name: 'VAT Identification Number',
        tooltip: 'CI + 9-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'VAT Identification Number',
        tooltip: 'CI + 9-digit code'
      }
    },
    LATVIA: {
      REGISTRATION_NUMBER: {
        name: 'Pievienotās vērtības nodokļa (PVN) reģistrācijas numurs',
        tooltip: 'LV + 11-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Pievienotās vērtības nodokļa (PVN) reģistrācijas numurs (VAT Number)',
        tooltip: 'LV + 11-digit code'
      }
    },
    LITHUANIA: {
      REGISTRATION_NUMBER: {
        name: 'PVM (Pridėtinės vertės mokestis) mokėtojo kodas',
        tooltip: 'LT + 9 or 12-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'PVM (Pridėtinės vertės mokestis) mokėtojo kodas (VAT Number)',
        tooltip: 'LT + 9 or 12-digit code'
      }
    },
    LUXEMBOURG: {
      REGISTRATION_NUMBER: {
        name: 'Numéro d‘identification à la TVA',
        tooltip: 'LU + 8-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Numéro d‘identification à la TVA (VAT Number)',
        tooltip: 'LU + 8-digit code'
      }
    },
    MAURITIUS: {
      REGISTRATION_NUMBER: {
        name: 'VAT Identification Number',
        tooltip: 'MU + 8-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'VAT Identification Number',
        tooltip: 'MU + 8-digit code'
      }
    },
    MEXICO: {
      REGISTRATION_NUMBER: {
        name: 'Registro Federal de Contribuyentes',
        tooltip: '3 or 4-character + 6-digit + 3-character code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Registro Federal de Contribuyentes (VAT Number)',
        tooltip: '3 or 4-character + 6-digit + 3-character code'
      }
    },
    MONACO: {
      REGISTRATION_NUMBER: {
        name: 'TVA intracommunautaire',
        tooltip: 'FR + 11-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'TVA intracommunautaire (VAT Number)',
        tooltip: 'FR + 11-digit code'
      }
    },
    NETHERLANDS: {
      REGISTRATION_NUMBER: {
        name: 'Btw-nummer',
        tooltip: 'NL + 9-digit + B + 2-digit'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Btw-nummer (VAT Number)',
        tooltip: 'NL + 9-digit + B + 2-digit'
      }
    },
    POLAND: {
      REGISTRATION_NUMBER: {
        name: 'Numer identyfikacji podatkowej',
        tooltip: 'PL + 10-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Numer identyfikacji podatkowej (VAT Number)',
        tooltip: 'PL + 10-digit code'
      }
    },
    PORTUGAL: {
      REGISTRATION_NUMBER: {
        name: 'Número de Identificação Fiscal / de Pessoa Coletiva',
        tooltip: 'PT + 9-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Número de Identificação Fiscal / de Pessoa Coletiva (VAT Number)',
        tooltip: 'PT + 9-digit code'
      }
    },
    ROMANIA: {
      REGISTRATION_NUMBER: {
        name: 'Codul de identificare fiscală',
        tooltip: 'RO + 2 to 10-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Codul de identificare fiscală (VAT Number)',
        tooltip: 'RO + 2 to 10-digit code'
      }
    },
    SERBIA: {
      REGISTRATION_NUMBER: {
        name: 'Poreski identifikacioni broj',
        tooltip: '9-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Poreski identifikacioni broj (VAT Number)',
        tooltip: '9-digit code'
      }
    },
    SLOVAKIA: {
      REGISTRATION_NUMBER: {
        name: 'Identifikačné číslo pre daň z pridanej hodnoty',
        tooltip: 'SK + 10-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Identifikačné číslo pre daň z pridanej hodnoty (VAT Number)',
        tooltip: 'SK + 10-digit code'
      }
    },
    SLOVENIA: {
      REGISTRATION_NUMBER: {
        name: 'Identifikacijska številka za DDV',
        tooltip: 'SI + 8-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Identifikacijska številka za DDV (VAT Number)',
        tooltip: 'SI + 8-digit code'
      }
    },
    SPAIN: {
      REGISTRATION_NUMBER: {
        name: 'Número de Identificación Fiscal',
        tooltip: 'ES + 1 character + 7 digits + 1 character'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Número de Identificación Fiscal (VAT Number)',
        tooltip: 'ES + 1 character + 7 digits + 1 character'
      }
    },
    SWEDEN: {
      REGISTRATION_NUMBER: {
        name: 'Momsregistreringsnummer',
        tooltip: 'SE + 12-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Momsregistreringsnummer (VAT Number)',
        tooltip: 'SE + 12-digit code'
      }
    },
    SWITZERLAND: {
      REGISTRATION_NUMBER: {
        name: 'Mehrwertsteuernummer',
        tooltip: 'CHE + 9-digit code'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Mehrwertsteuernummer (VAT Number)',
        tooltip: 'CHE + 9-digit code'
      }
    },
    UNITED_KINGDOM: {
      REGISTRATION_NUMBER: {
        name: 'Value added tax registration number',
        tooltip: 'GB + 9 or 12-digit / GBGD + 3-digit / GBHA + 3-digit'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Value added tax registration number (VAT Number)',
        tooltip: 'GB + 9 or 12-digit / GBGD + 3-digit / GBHA + 3-digit'
      }
    }
  },
  initialLoading: {
    error: 'We apologize for the delay. Our developers will analyse the issue.',
    message: 'Just a moment, OnceForAll is starting ...'
  },
  intervention: {
    dateForm: {
      error: 'The date cannot be earlier than the opening date of the project',
      fieldLabel: 'Date',
      openButton: 'Set an intervention date',
      saveSuccess: 'The project intervention start date has been set',
      title: 'Set an intervention date'
    },
    ended: {
      buttonTitle: 'End participation of this organisation',
      confirmEndOrganisation: {
        content: 'Are you sure you want to end the participation of %{organisationName} in the project?',
        warning: 'This organisation and its subcontractors will no longer be able to access the project'
      },
      endSuccess: '%{organisationName} is no longer part of the project',
      name: ' (ended)',
      tooltip: 'The participation of this organisation has been ended the %{endDate}'
    },
    invited: {
      external: {
        CLIENT: 'Waiting for client registration',
        GENERAL_CONTRACTOR: 'Waiting for general contractor registration',
        PROJECT_MANAGER: 'Waiting for project manager registration',
        PROJECT_MANAGER_CLIENT: 'Waiting for project manager registration',
        SERVICE_PROVIDER: 'Waiting for provider registration',
        SUB_CONTRACTOR: 'Waiting for subcontractor registration'
      },
      internal: {
        CLIENT: 'Waiting for client approval',
        GENERAL_CONTRACTOR: 'Waiting for general contractor approval',
        PROJECT_MANAGER: 'Waiting for project manager approval',
        PROJECT_MANAGER_CLIENT: 'Waiting for project manager approval',
        SERVICE_PROVIDER: 'Waiting for service provider approval',
        SUB_CONTRACTOR: 'Waiting for subcontractor approval'
      }
    },
    organisationDeactivated: '(Organisation disabled)',
    removed: {
      removeSuccess: 'Organisation %{organisationName} has been removed'
    },
    role: {
      CLIENT: 'Client',
      GENERAL_CONTRACTOR: 'General contractor',
      PROJECT_MANAGER: 'Project manager',
      PROJECT_MANAGER_CLIENT: 'Project manager',
      SERVICE_PROVIDER: 'Service provider',
      SUB_CONTRACTOR: 'Subcontractor'
    }
  },
  invalidOrganisationDocuments: {
    emptyMessage: 'No invalid documents to show',
    title: 'Invalid documents'
  },
  invitation: {
    externalInvitationSuccessTitle: 'Invitation sent!',
    received: {
      actions: {
        accept: 'Accept this invitation',
        reject: 'Decline this invitation'
      },
      emptyList: 'You have no invitation to process',
      expandList: 'See all invitations',
      message: {
        PROJECT_NOT_AUTOMATICALLY_ACCEPTED: 'You have been invited to join project __s%{projectName}__s',
        RELATIONSHIP_NOT_AUTOMATICALLY_ACCEPTED: 'You have been invited by __s%{invitingOrganisationName}__s to join their network as a subcontractor.',
        RELATIONSHIP_SUGGESTED: 'As subcontractor, you might be interested to share your documents with __s%{invitingOrganisationName}__s',
        USER_PENDING: 'The user __s%{firstName} %{lastName}__s has requested to join your organisation.',
        projectInvitedBy: 'Invited by __s%{invitingOrganisationName}__s'
      },
      title: 'Received invitations'
    },
    sent: {
      clone: 'The user registered the organisation %{cloneRegistrationNumber} from your invitation sent to the organisation %{originalRegistrationNumber}',
      email: 'Email',
      invitationDate: 'Receipt date',
      invitationSentDate: 'Sending date',
      noResult: 'No invitation to display',
      resentOn: 'Resent on %{date}',
      status: 'Status',
      waitingForApproval: 'Waiting for subcontractor approval',
      waitingForRegistration: {
        client: 'Waiting for client registration',
        subcontractor: 'Waiting for subcontractor registration'
      }
    },
    suggestion: {
      accept: 'You will share your documents with',
      actions: {
        accept: 'You will share your documents with %{invitingOrganisationName}',
        reject: 'You do not want to share your documents with %{invitingOrganisationName}'
      },
      expandList: 'See all suggestions',
      reject: 'You do not want to share your documents with',
      rejectionReason: 'Select a rejection reason of the suggestion',
      rejectionSuccess: '%{invitingOrganisationName} has been removed from your clients suggestions!',
      title: 'Suggestions are based on invitations you have received by email but related to a different organisation than yours'
    }
  },
  invite: {
    alreadyExists: {
      action: 'Add',
      text: 'You can directly add it',
      title: 'This organisation is already registered on the OnceForAll network'
    },
    alreadyInvited: {
      text: 'You have already sent an invitation to this email address to have this organisation added to the OnceForAll network.',
      title: 'This invitation already exists'
    },
    cancel: 'Remove invitation',
    cancelSuccessful: 'Your invitation has been removed.',
    customMessage: 'Message',
    email: 'Email address',
    firstName: 'First name',
    inactive: {
      text: 'Please contact our customer service for more information.',
      title: 'This organisation is currently inactive'
    },
    language: 'Language',
    lastName: 'Last name',
    messageSectionSubtitle: 'You can keep the pre-filled message or modify it',
    messageSectionTitle: 'Invitation message',
    organisationName: 'Organisation name',
    organisationSectionTitle: 'Which organisation would you like to invite?',
    phoneNumber: 'Phone number',
    unknown: {
      text: 'You can invite it to join the OnceForAll network.',
      title: 'No organisation with this Registration Number seems to exist'
    },
    userSectionTitle: 'To whom should we send this invitation?'
  },
  invoices: {
    amountDue: 'Due amount',
    amountTotal: 'Total amount',
    creationDate: 'Issued on %{date}',
    download: 'Download this invoice',
    dueOn: 'Due date is %{date}',
    loadMore: 'Show next 10 invoices',
    noResult: 'No invoice to show',
    paidOn: 'Paid on %{date}',
    sentTo: 'Billed to',
    status: {
      NOT_PAID: 'Payment due',
      PAID: 'Paid',
      PAYMENT_DUE: 'Payment due',
      POSTED: 'Payment due'
    },
    statusTitle: 'Status',
    title: 'Invoices'
  },
  language: {
    de: 'Deutsch',
    en: 'English',
    fr: 'Français',
    it: 'Italiano'
  },
  mandate: {
    details: {
      backToList: 'Back to mandate list',
      details: {
        certifyingThirdParty: 'Certifying third party',
        creationDate: 'Creation date',
        documentType: 'Document type',
        perimeter: {
          GROUP: 'Group',
          ORGANISATION: 'Organisation',
          label: 'Mandate perimeter'
        },
        title: 'Details',
        updateDate: 'Update date'
      },
      editMessage: {
        broadcast: "To edit broadcast mandate's details, please",
        collection: "To edit collection mandate's details, please"
      },
      information: {
        broadcast: 'Broadcast information',
        collection: 'Collection information',
        copyToClipboard: 'Copy in clipboard',
        showValue: 'Show value',
        website: 'Website'
      },
      title: {
        broadcast: 'Broadcast mandate for',
        collection: 'Collection mandate for'
      }
    },
    field: {
      CONVENTION_NUMBER: 'Numéro de convention',
      EMAIL: 'Adresse électronique',
      FIRST_NAME: 'Prénom',
      INSURANCE_COMPANY: 'Compagnie - Agent - Courtier',
      KEY: 'Clé',
      LAST_NAME: 'Nom',
      LOGIN: 'Username',
      PASSWORD: 'Password',
      PHONE: 'Numéro de téléphone',
      POLICE_NUMBER: 'Numéro de police',
      REGION: 'Région',
      REGISTRATION_NUMBER: 'SIRET',
      SOCIAL_SECURITY_NUMBER: 'Numéro de sécurité sociale'
    },
    list: {
      comment: 'Comment',
      creationDate: 'Creation date',
      message: {
        email: 'service.clients@onceforall.com',
        firstPart: {
          broadcast: {
            part1: 'Broadcast mandate is an option included in your subscription allowing us to broadcast valid documents(1) of your organisation on other platforms. With the broadcast mandate, you focus on your business.',
            part2: '(1) The document "Liste des salariés étrangers soumis à autorisation de travail" can not be updated. The document "Attestation fiscale" must be edited for the current year. Specific documents requested by clients, not available on our platform, must be updated by your organisation.'
          },
          collection: 'Collection mandate is an option already included in your subscription, except Expérience plan, allowing us to manage the update of your documents in Attestation Légale. With the collection mandate, you focus on your business.'
        },
        link: 'clicking here',
        secondPart: 'How to activate it? Download the document by ',
        thirdPart: ' and send the completed and signed document to '
      },
      noResult: {
        broadcast: 'No broadcast mandate for this organisation',
        collection: 'No collection mandate for this organisation'
      },
      platform: 'Platform',
      subtype: 'Document type',
      thirdParty: 'Certifying third party',
      updateDate: 'Update date'
    },
    planUpgradable: 'Your current offer needs to be upgraded in order to broadcast documents on other platforms.',
    platform: {
      AWS: 'AWS',
      EATTESTATIONS: 'e-Attestations',
      MYPROCUREMENT: 'MyProcurement',
      PROVIGIS: 'Provigis'
    },
    platformWebsite: "Open platform's website",
    thirdPartyGroup: {
      CIBTP: 'Congés Intempéries BTP - CIBTP',
      CNETP: 'Caisse Nationale des Entrepreneurs de Travaux Publics - CNETP',
      NET_ENTREPRISE: 'Net Entreprise',
      PROBTP: 'PRO BTP',
      TESE: 'Titre emploi service entreprise - TESE',
      URSSAF: 'URSSAF',
      URSSAF_AUTOENT: 'URSSAF Autoentrepreneur',
      URSSAF_INDEP: 'URSSAF Indépendant'
    },
    thirdPartyWebsite: "Open certifying third party's website"
  },
  menu: {
    bdr: '[Bâtisseur de Relations]',
    clients: 'Clients',
    dashboard: 'Dashboard',
    documents: 'Documents',
    help: 'Help center',
    home: 'General dashboard',
    news: '[]',
    panda: 'Access PanDA',
    profile: 'My profile',
    projects: 'Projects',
    settings: 'Settings',
    subcontractors: 'Subcontractors',
    vitrine: 'Create my references list'
  },
  message: {
    changesSaved: 'Changes have been saved!',
    exportRequestSuccess: 'Your request has been registered. You will soon receive your export by email.',
    lastUpdateDate: 'Last update date:',
    loading: 'Loading',
    missingPermission: 'You do not have the required permission to sign this document',
    missingRequiredFields: 'All required fields must be completed',
    missingSelectedOrganisation: 'You have to select an organisation',
    moreResults: '%{results} other results',
    noData: 'These data are not yet available',
    pageAccessDenied: 'Sorry, you cannot access this page',
    pageNotFound: "Sorry, this page couldn't be found",
    projectNotEditable: 'To edit disabled fields, please',
    roleNotAllowed: "Your role doesn't allow you to access this section. Please contact our customer service to change it.",
    selectedOrganisationDenied: "You don't have access to this organisation, but your request has been send to the organisation manager",
    textCounter: '%{counter} characters on %{maxLength}'
  },
  notification: {
    document: {
      atDate: 'Your __s%{documentName}__s document is missing for the year __s%{year}__s and is required in  __s%{projectsCount}__s projects. Please upload a valid version for the year __s%{year}__s. Once uploaded, the file will be verified by our Production team within 48h and will then be visible on OnceForAll plateform.',
      collectionMandateDisabled: {
        FRANCE: 'The document %{documentName} is no longer collected by Attestation Légale',
        GERMANY: 'The document %{documentName} is no longer collected by OnceForAll'
      },
      created: '%{documentName} has been added to your dossier.',
      depositor: 'You can now submit documents and share them with your clients.',
      remind: '%{userFullName} reminds you to update the documents of your organisation %{organisationName}',
      requalified: '%{previousDocumentName} has been renamed to %{documentName} by our team',
      validUntil: ' It will be valid until %{expirationDate}.',
      validated: 'Your document %{documentName} has been validated by our team.',
      yourDocument: 'Your document __s%{documentName}__s'
    },
    emptyList: 'You have reviewed all your notifications',
    organisation: {
      automaticAcceptationEnabled: 'You accept automatically invitations as a subcontractor now. You can set this parameter to manual acceptation.',
      deactivation: {
        inviting: '%{organisationName} can not join your network because this organisation has been deactivated.',
        relatedAsClient: '%{organisationName} has been deactivated. You can still access its documents.',
        relatedAsSubcontractor: '%{organisationName} has been deactivated.'
      }
    },
    project: {
      accepted: 'You have joined the project %{projectName}',
      closed: 'The project %{projectName} has been closed by %{organisationOwnerName}. You can still access the project and its documents.',
      organisationEnded: 'Your organisation %{invitedOrganisationName} is no longer part of the project %{projectName}.',
      rejected: 'Organisation %{invitedOrganisationName} refused to join project %{projectName} because: %{rejectionReason}',
      updatedRequiredDocumentsInProjectDossierOverview: 'The documents required for the dossier overview of project %{projectName} have changed.'
    },
    relationship: {
      accepted: {
        AS_CLIENT: 'You have joined the network of %{invitingOrganisationName} as a client',
        AS_SUBCONTRACTOR: 'You have joined the network of %{invitingOrganisationName} as a subcontractor'
      },
      rejected: 'Organisation %{invitedOrganisationName} refused to join your network because: %{rejectionReason}'
    },
    user: {
      linked: '%{firstName} %{lastName} has joined %{organisationName}.',
      permissionsUpdated: {
        MANAGE_PROJECT: {
          ADDITION: '%{firstName} %{lastName} can now manage projects for %{organisationName}',
          DELETION: '%{firstName} %{lastName} can no longer manage projects for %{organisationName}'
        },
        SIGN: {
          ADDITION: '%{firstName} %{lastName} can now sign online documents for %{organisationName}',
          DELETION: '%{firstName} %{lastName} can no longer sign online documents for %{organisationName}'
        }
      },
      roleUpdated: {
        CONSULTANT: '%{firstName} %{lastName} has now Consultant role for %{organisationName}',
        EXPLORER: '%{firstName} %{lastName} has now Explorer role for %{organisationName}',
        INVITING: '%{firstName} %{lastName} has now Relation manager role for %{organisationName}',
        MANAGER: '%{firstName} %{lastName} has now Account manager role for %{organisationName}'
      }
    }
  },
  opera: {
    'platform-ACTRADIS': {
      message: 'Master platform : ACTRADIS'
    },
    'platform-OFA': {
      message: 'Master platform : OFA'
    }
  },
  organisation: {
    accessCode: {
      name: 'Access Code',
      tooltip: 'Connect directly with your supplier using the code they may have given you'
    },
    businessLine: {
      AGRICULTURE: 'Agriculture',
      CLEANING: 'Cleaning',
      CONSTRUCTION: 'Construction',
      MANUFACTURING: 'Manufacturing',
      METAL_PRODUCTS: 'Manufacture of fabricated metal products',
      OTHER: 'Other activity',
      PARCEL_DELIVERY: 'Parcel delivery',
      RENTAL_LEASING: 'Rental and leasing activities',
      SAFETY: 'Safety',
      SERVICE_ACTIVITIES: 'Service activities',
      TEMPORARY_WORK: 'Temporary work',
      TRANSPORTATION: 'Transportation',
      WASTE_MANAGEMENT: 'Waste management',
      title: 'Business line'
    },
    create: {
      cautionNotice: 'If you wish to file your documents online, be sure to register the organisation with which you have contracted with your client.',
      errors: {
        sirenNotMatching: 'The SIREN is not matching with the SIRET'
      },
      privacyPolicyAccepted: 'I accept the privacy policy *',
      requiredNotice: '* Mandatory fields',
      step1: 'Step 1',
      step1Text: "Enter your organisation's %{idNumberName}",
      step2: 'Step 2',
      step2Text: 'Verify or complete information',
      termsAccepted: 'I accept the terms and conditions *',
      title: 'Register my organisation'
    },
    createOrganisation: 'Register or join an organisation',
    createOrganisationDeactivated: '%{organisationName} has been deactivated. You cannot join it.',
    createOrganisationFound: 'This organisation does exist on OnceForAll. Click on "Continue" to join it.',
    createOrganisationFoundAndLinked: 'This organisation does exist on OnceForAll and you are already linked to it',
    createOrganisationFoundInILG: 'This organisation does not yet exist on OnceForAll. Click on "Continue" to create it.',
    createOrganisationNotFound: 'This organisation is unknown. Please check your SIRET number.',
    createOrganisationSuccess: 'Your organisation has been created',
    deactivated: {
      title: 'Organisation disabled',
      tooltip: 'This organisation has been deactivated, you cannot select it.',
      tooltipBackOffice: 'This organisation has been deactivated.'
    },
    delete: {
      confirmDeleteOrganisation: {
        content: 'Are you sure you want to remove %{organisationName}?',
        warning: {
          client: 'This organisation will not see your documents anymore.',
          subcontractor: 'You will not be able to see its documents anymore.'
        }
      },
      success: 'Organisation %{organisationName} has been removed',
      title: 'Remove organisation',
      tooltip: 'You cannot remove this organisation because you are sharing at least one project with it. Only the project owner can remove an organisation from a project!'
    },
    depositorService: {
      noFile: 'No file to download',
      notActivated: 'This organisation is no longer depositor.'
    },
    details: "Organisation's details",
    fullName: 'Organisation name',
    inactive: 'This organisation is currently inactive. Please contact our customer service for more information.',
    invite: 'Invite the organisation "%{input}" to join the network',
    registrationNumber: 'Registration Number',
    remainingUserAccounts: '%{count} users left',
    search: {
      alreadyClient: 'This organisation is already one of your clients',
      alreadyInvited: 'You have already invited this subcontractor',
      alreadyPartOfProject: 'This organisation is already part of the project',
      alreadySelected: 'This organisation is already selected',
      alreadySubcontractor: 'This organisation is already one of your subcontractors',
      inputLabel: 'Search an organisation',
      invite: {
        action: 'Invite',
        text: 'You can invite it to join the OnceForAll network',
        title: 'Cannot find the organisation you are searching?'
      },
      lastSelected: 'Last selected organisations:',
      notfound: 'This organisation does not have an account on the platform yet',
      placeholder: 'Organisation name or identification number',
      self: 'You cannot add yourself',
      specifySearch: 'There may be more than 10 results. Please specify your search.'
    },
    selectOrganisation: {
      all: 'All your organisation',
      showAll: 'Show all organisations',
      title: 'Search an organisation'
    },
    users: {
      noResult: {
        line1: 'The user you search for does not belong to this organisation yet.',
        line2: 'Do you want to invite this user?'
      },
      searchLabel: 'Find a user',
      title: 'Users'
    },
    viewDetails: 'View details',
    website: 'Website'
  },
  organisationSetting: {
    cantEditMessage: "To edit organisation's details, please",
    cantModifyRole: 'To modify users roles and permission, please',
    contactCustomerService: 'contact customer service',
    detailsTitle: 'Details',
    mandates: {
      broadcast: {
        notDepositor: 'Active depositor service is required to access the broadcast mandates',
        notManager: 'Only the account manager can access the broadcast mandates',
        title: 'Broadcast mandates'
      },
      collection: {
        notDepositor: 'Active depositor service is required to access the collection mandates',
        notManager: 'Only the account manager can access the collection mandates',
        title: 'Collection mandates'
      }
    },
    subscriptionAndInvoicesTabDisabled: 'Only the Account Manager can access both the subscription and the invoices',
    subscriptionAndInvoicesTitle: 'Subscription & Invoices',
    upload: 'Upload',
    uploadLogo: "Upload organisation's logo",
    usersTitle: 'Users'
  },
  pagination: {
    items: 'Items',
    of: 'of',
    to: 'to'
  },
  panda: {
    access: {
      confirm: 'Access PanDA',
      text1: 'You want to access PanDA.',
      text2: 'PanDA platform allows you to simplify and secure the approvment of your subcontractors.',
      text3: 'In just a few clicks, dematerialize the entire process of approving subcontractors working on your sites.',
      text4: 'More information about PanDA',
      text5: 'By clicking on "Access PanDA", your user account and your companies on OnceForAll platform will be automatically synced to PanDA.'
    },
    discover: {
      cancel: 'I do not want to manage my requests for approval via PanDA',
      cta: 'Discover PanDA',
      text1: '__sManage requests for approvals online.__s',
      text2: 'You have created and manage your project on Once for All platform. What about managing your requests for approvals online with the PanDA platform?'
    }
  },
  plan: {
    actions: {
      add: 'Add options',
      contactUs: 'Contact us',
      upgrade: 'Upgrade offer'
    },
    currentPlan: 'Your current offer',
    free: 'FREE',
    message: {
      upgradeSuccess: 'Your change of offer has been taken into account. The customer service will contact you soon.'
    },
    modal: {
      additionalProjects: 'Additional projects',
      additionalProjectsOption: 'one-off payment, unlimited run-time',
      additionalUsers: 'Additional users',
      depositorService: 'Enable all my clients to access my documents',
      title: 'Add options to %{type} offer'
    },
    options: {
      projectInclude: 'Projects included',
      userInclude: 'Users included'
    },
    perMonth: '/ month',
    specialPrice: '*19€ for small businesses'
  },
  project: {
    actionProjectClosed: 'This action is not possible because this project is closed',
    additionalNotes: 'Description',
    additionalNotesInfo: 'This description is visible by any organisation participating in the project',
    address: 'Project address',
    backToDashboard: 'Back to project dashboard',
    backToProjects: 'Back to projects list',
    buttonDocuments: {
      download: 'Download project dossier',
      expand: {
        tooltip: 'You must activate the depositor service to see your document list'
      },
      print: 'Print project dossier',
      showDocuments: 'Show documents'
    },
    close: 'Close project',
    closeSuccess: 'This project is now closed.',
    closedProject: '(closed)',
    closingDate: 'Closing date',
    confirmProjectClosure: {
      content: "Documents and status will still be available.\nBut you won't be able to invite organisations to this project and all pending invitations will be cancelled.",
      title: 'Are you sure you want to close this project?',
      warning: 'This action is irreversible, a project cannot be reopened!\t'
    },
    create: {
      button: 'Add a new project',
      creationSuccess: 'Project %{name} has been created!',
      projectCreditsTooltip: 'You have no credit left, please contact the customer service to buy new credits',
      title: 'Add new project'
    },
    creditsNominative: '__s%{count}__s nominative project credits left',
    creditsNominative_0: '__s%{count}__s nominative project credit left',
    creditsNominative_1: '__s%{count}__s nominative project credit left',
    creditsStandard: '__s%{count}__s standard project credits left',
    creditsStandard_0: '__s%{count}__s standard project credit left',
    creditsStandard_1: '__s%{count}__s standard project credit left',
    description: {
      notice: 'Once the project is created, you can contact the customer service to edit those information',
      requiredNotice: '* Mandatory fields',
      title: 'Project description'
    },
    details: 'Details',
    documentAtDateMessage: 'The uploaded document must be valid at the project opening date : __s%{date}__s',
    documentAtInterventionDateMessage: 'The uploaded document must be valid at the project intervention start date : __s%{interventionDate}__s',
    documents: 'Documents',
    documentsStates: {
      ALMOST_EXPIRED: 'Soon expired',
      MISSING: 'Missing / Expired / Rejected',
      VALID: 'Valid'
    },
    documentsStillValid: 'still valid',
    edit: {
      addOrganisation: 'Add an organisation',
      addOrganisationExternalSuccess: 'An invitation has been sent to the organisation %{name}',
      addOrganisationInternalSuccess: 'The organisation %{name} has been invited to join the project',
      changeOrganisation: 'Change organisation',
      changeRole: 'Change role',
      descriptionsPerRole: {
        CLIENT: '<span>A client can invite organisations to the project (as general contractors, PM & service provider) and get documents for each of them.</span>',
        GENERAL_CONTRACTOR: '<span>A general contractor will provide its documents, invite organisations to the project (as client, general contractors, subcontractors, PM & service provider) and get documents for each of them.</span>',
        PROJECT_MANAGER: '<span>A project manager will provide its documents, invite organisations to the project (as client, general contractors, subcontractors, PM & service provider) and get documents for each of them.</span>',
        PROJECT_MANAGER_CLIENT: '<span>A project manager will provide its documents, invite organisations to the project (as client, general contractors, subcontractors, PM & service provider) and get documents for each of them.</span>',
        SERVICE_PROVIDER: '<span>A service provider will provide its documents, invite providers and get their documents.</span>',
        SUB_CONTRACTOR: '<span>A subcontractor will provide its documents, invite subcontractors and get their documents.</span>'
      },
      editDocuments: 'Apply modifications',
      editProjectDescription: 'Edit project description',
      editProjectDescriptionSuccess: 'Project %{name} has been edited!',
      editRequiredDocuments: 'Edit required documents',
      externalInvitationSuccess: 'Once the invited user registers on OnceForAll and adds his organisation, that organisation will automatically be added to the project.',
      message: {
        EXTERNAL: 'Invitation via email',
        INTERNAL: 'Linking'
      },
      notEditable: 'You first need to upload the specifications document and/or the CCRD in order to require this document. Since then, the customer service will create this document as soon as possible.',
      organisation: 'Select an organisation',
      requiredForDossierOverviewStatus: 'Required for project dossier overview status',
      requiredForProject: 'Required for project',
      roleAs: 'As',
      roleType: 'Select a role',
      seeRequiredDocuments: 'See required documents',
      title: 'Add an organisation',
      warning: '<strong>Warning:</strong> If you edit the project opening date, all the decennial certificates at the project opening date will be recalculated. Please ensure that you are certain of the modification before confirming, to avoid any errors.'
    },
    exportDossier: 'Export project dossier',
    exportQuitus: 'Download project overview report',
    goToChart: 'See project chart',
    grantAccess: {
      button: 'Grant access to the project',
      missing: 'If you cannot find a user in the list, you can add it afterwards by contacting your account manager or contact the ',
      missingLink: 'customer service.',
      title: 'Grant access to the project',
      user: {
        fullName: 'Name',
        role: 'Role',
        viewProject: 'View Project'
      }
    },
    internalNotes: {
      author: 'Note from %{fullName}',
      creationDate: 'Published on ',
      newInternalNote: 'New internal note',
      title: 'Internal notes'
    },
    internalReference: 'Internal reference',
    invite: {
      client: {
        defaultMessage: 'Regarding your participation to the project %{projectName}, %{userName} from %{organisationName} invites you to register on the OnceForAll platform of Attestation Légale in order to facilitate management of your subcontractor certificates (business registration, health insurance, liability insurance, etc.).\nOnceForAll is an independent service provided by Attestation Légale for the construction sector. It helps to secure your business relations by assisting you to maintain a complete and up-to-date set of company-certification documents.\nAs their client, you will then have full and unlimited access to the online documents of every organisations which are part of the project %{projectName}.'
      },
      depositor: {
        defaultMessage: 'Regarding your participation to the project %{projectName}, %{userName} from %{organisationName} invites you to register on the OnceForAll platform of Attestation Légale in order to facilitate management of subcontractor certificates (business registration, health insurance, liability insurance, etc.).\nOnceForAll is an independent service provided by Attestation Légale for the construction sector. It helps to secure your business relations by assisting you to maintain a complete and up-to-date set of company-certification documents.\nAs their subcontractor, you will give %{organisationName} access to your online documents.\nYou can give all your clients access to your online folder. It is still up to you to decide who can view your documents online.'
      },
      title: 'Invite an organisation'
    },
    myProjects: 'Projects',
    name: 'Project name',
    noProjects: 'No project found',
    notifications: {
      cancel: 'I already did it',
      grantAccess: 'Did you grant your colleagues access to this project?',
      requiredDocuments: 'Did you set required documents for this project?'
    },
    openingDate: 'Project opening date',
    organisationDocuments: 'Documents for the organisation %{organisationName}',
    organisationHasNoDocuments: 'The organisation has no document',
    organisations: {
      title: 'Organisations'
    },
    ownerOrganisation: 'Owner',
    participants: {
      description: 'participants on the project',
      title: 'Participants'
    },
    projectAccepted: "The project's invitation has been accepted!",
    projectAlreadyClosed: 'This project is closed. You can no longer join it.',
    projectAlreadyReplied: "You have already replied to the project's invitation",
    projectClosedChip: 'Project closed',
    projectInviterRemoved: 'You cannot join this project because the organisation that invited you is not part of the project anymore.',
    projectRejected: "The project's invitation has been declined",
    provisionalAcceptanceDate: 'Provisional acceptance date',
    quitus: 'Quitus',
    quitusDescription: "of project's participants have a valid dossier overview",
    requiredDocuments: {
      message1: '__sRequired for project__s: The documents selected in this column will be collected for all the companies present on the project according to their business line and country.',
      message2: '__sRequired for project dossier overview status__s: This column allows you to customize the project dossier overview status. Its validity will be calculated from the selected documents. For instance: RIB opération checked in Collected for the project  but not in Required for project dossier overview status: it will be requested from the company but will not invalidate the project dossier overview status if it is missing.',
      title: 'Required Documents',
      tooltip: {
        FOREIGN: 'This document is required only for foreign companies and branches',
        businessLines: 'This document is only required for organisations in the following sectors: ',
        businessLines_1: 'This document is only required for organisations in the following sector: '
      }
    },
    roleForm: {
      change: 'Change role',
      choose: 'Choose this role',
      client: {
        firstPoint: 'See all the organisations participating to the project',
        intro: 'Create a project as a __sClient__s allows to:',
        secondPoint: 'Invite only general contractors',
        thirdPoint: 'Get the documents of all the organisations of the project'
      },
      generalContractor: {
        firstPoint: 'See organisations participating to the project',
        intro: 'Create a project as a __sGeneral contractor__s allows to:',
        secondPoint: 'Invite organisations to the project (client, general contractors and subcontractors)',
        thirdPoint: 'Get the documents of all your subcontractors'
      },
      notice: "Please select __s%{organisationName}__s's role in this project",
      projectManagerClient: {
        firstPoint: 'See all the organisations participating to the project',
        intro: 'Create a project as a __sProject Manager__s allows to:',
        secondPoint: 'Invite organisations to the project (client, general contractors and subcontractors)',
        thirdPoint: 'Get the documents of all the organisations of the project'
      },
      title: 'Project role'
    },
    search: {
      notfound: 'This project does not exist',
      placeholder: 'Project name'
    },
    selectIntervention: {
      invitedBy: 'Invited by %{invitingOrganisationName}',
      message: 'Your organization has multiple roles in this project, please select the role with which you would like to view this project.',
      title: 'Select role'
    },
    showInvalidDocumentsPage: 'Show invalid documents',
    subcontractors: {
      description: 'subcontractors on the project',
      title: 'Subcontractors'
    },
    tree: {
      title: 'Organisation chart',
      clients: 'Client',
      projectManagers: 'Project Managers',
      supplyChain: 'Supply Chain'
    },
    type: {
      NOMINATIVE: 'Nominative',
      STANDARD: 'Standard'
    },
    typeForm: {
      NOMINATIVE: {
        fifthPoint: 'Have a dedicated document verification for the operation',
        firstPoint: 'Provide a dedicated space for the project',
        fourthPoint: 'Collect specific documents',
        intro: 'Creating a Nominative project allows you to:',
        secondPoint: 'Manage the subcontracting chain',
        thirdPoint: 'Pilot the construction site thanks to the dashboard'
      },
      STANDARD: {
        firstPoint: 'Provide a dedicated space for the project',
        intro: 'Creating a Standard project allows you to:',
        secondPoint: 'Manage the subcontracting chain',
        thirdPoint: 'Pilot the construction site thanks to the dashboard'
      },
      change: 'Change type',
      choose: 'Select this type',
      notice: 'Please select the project type you wish to create',
      title: 'Project type'
    },
    upgradeToNominative: {
      title: 'Upgrade to nominative project',
      tooltip: 'There is no sufficient nominative project credits left'
    },
    viewDetails: 'View details'
  },
  registerFirstTime: {
    import: 'Upload and share your documents',
    joinOrganisation: 'Join an organisation that already exists on OFA.',
    joinOrganisationSubtitle: "Use that organisation's registration number!",
    network: 'Grow your network',
    newOrganisation: 'You can register a new organisation.',
    newOrganisationSubtitle: 'Provide your registration informations to begin !',
    optionsTitle: 'Your organisation is not yet on OnceForAll?',
    participate: 'Participate in projects',
    start: 'Click below to start!',
    startButton: 'Register your organisation',
    subtitle: 'With us you can:',
    title: 'First time on OFA?',
    view: 'See the documents of your subcontractors'
  },
  rejectionReason: {
    displayLabel: 'Invitation declined: ',
    label: 'Select a rejection reason',
    reason: {
      ACTRADIS_MEMBER: 'Already member of an interoperated platform',
      ALREADYACTIVECUSTOMER: 'Inscription ongoing',
      ALREADYMEMBEROFAFREEPLATFORM: 'Can already share its dossier outside OnceForAll',
      CESSATIONOFACTIVITY: 'Cessation of activity',
      CESSATION_OF_ACTIVITY: 'Cessation of activity',
      DOINVITATIONERROR: 'Invitation mistake',
      DO_INVITATION_MISTAKE: 'Invitation mistake',
      FILE_ALREADY_TRANSMITTED: 'Dossier already transmitted',
      FREE_PLATFORM_MEMBER: 'Can already share its dossier outside OnceForAll',
      INCORRECTCONTACTDETAILS: 'Contact details are wrong',
      INSCRIPTION_ONGOING: 'Inscription ongoing',
      INSUFFICIENT_CUSTOMERS_NUMBER: 'Insufficent clients on OnceForAll',
      KEEP_SENDING_FILE_BY_EMAIL: 'Wish to send documents only by mail or e-mail',
      NOBUDGET: 'Do not want to pay to share its dossier',
      NOLONGERRESPONDING: 'Unreachable',
      NOT_INFORMED: 'Was not informed by its client',
      NOT_MANDATORY: 'Not mandatory',
      NOT_WORKING_WITH_ORGANISATION: "I don't work with this organisation",
      NO_ACTIVE_CONTRACT: 'I do not have any active contract with this client',
      NO_FILE_SHARING_WANTED: 'Does not want to share an online dossier',
      NO_LONGER_WORKING_WITH_ORGANISATION: 'I no longer work with this organisation',
      NO_REASON_GIVEN: 'No reason given',
      PLATFORM_SECURITY_SCEPTIC: 'Feel unsure about the security of the OFA platform',
      PRICE: 'Do not want to pay to share its dossier',
      PRICETOOHIGH: 'Do not want to pay to share its dossier',
      SUBJECT_STUDIED_BY_MANAGEMENT: 'The subject is under study at management level',
      UNDERREVIEW: 'The subject is under study at management level',
      UNKNOWN_CLIENT: "I don't know this client",
      UNKNOWN_ORGANISATION: "I don't know this organisation",
      UNREACHABLE: 'Unreachable',
      WORKS_WITH_ANOTHER_ORGANISATION: 'This client works with another one of my organisations',
      WRONG_CONTACT_INFORMATIONS: 'Contact details are wrong'
    },
    title: 'Invitation from %{invitingOrganisationName}'
  },
  relationship: {
    errorDepositorService: 'To manage invitations received, you need to upgrade your offer.'
  },
  resendInvitationReason: {
    explanatory: 'Please indicate why you are resending this invitation',
    placeholder: "I'm resending this invitation because...",
    reason: 'Reason',
    title: 'Resend Invitation'
  },
  settings: {
    collectorNotifications: 'Collector notifications',
    collectorNotificationsMention: 'Subscribe to receive weekly overviews by email.\nA weekly report displays the dossier status of all your subcontractors.',
    invitation: {
      priorAcceptation: {
        label: 'Automatically accept invitations as a subcontractor',
        notDepositor: "You cannot change this parameter if you don't share documents on OnceForAll",
        notManager: "You don't have enough rights to modify this setting"
      },
      title: 'Invitation management'
    },
    mySettings: 'Settings',
    subscribeTo: {
      COLLECTOR_EVENT: 'Subscribe to event notification',
      COLLECTOR_EVENT_PROJECT: 'Subscribe to event notification per project',
      COLLECTOR_PERIODIC: 'Subscribe to weekly overview',
      COLLECTOR_PERIODIC_PROJECT: 'Subscribe to weekly overview per project'
    },
    tooltip: {
      COLLECTOR_PERIODIC: 'You have no subcontractor',
      COLLECTOR_PERIODIC_PROJECT: 'You are not part of any project'
    }
  },
  signature: {
    canceledMessage: 'The signature of the document has been refused.',
    successMessage: 'The document was signed with success.'
  },
  subcontractor: {
    accessCode: {
      download: 'Download access code',
      label: 'Use access code',
      modal: {
        errorNotFound: "This access code doesn't exist or has already been used.",
        message: "Please indicate your access code in order to have access to the subcontractor's dossier.",
        title: 'Use access code'
      },
      success: 'Subcontractor has been added to your list!'
    },
    add: {
      addSuccess: 'The organisation %{name} has been added to your subcontractors list!',
      button: 'Add a subcontractor',
      inviteSuccess: 'Invitation sent. Waiting for subcontractor %{name} approval',
      title: 'Add a subcontractor'
    },
    archives: 'Archives',
    documents: 'Documents',
    export: 'Export subcontractors dossier',
    invitations: {
      sent: 'Invitations sent'
    },
    invite: {
      defaultMessage: '%{userName} from %{organisationName} invites you to register on the OnceForAll platform of Attestation Légale in order to facilitate management of subcontractor certificates (business registration, health insurance, liability insurance, etc.).\nOnceForAll is an independent service provided by Attestation Légale for the construction sector. It helps to secure your business relations by assisting you to maintain a complete and up-to-date set of company-certification documents.\nAs their subcontractor, you will give %{organisationName} access to your online documents.\nYou can give all your clients access to your online folder. It is still up to you to decide who can view your documents online.',
      inviteSuccess: 'Once the invited user registers on OnceForAll and adds his organisation, that organisation will automatically be linked to yours as one of its subcontractors.',
      reinviteDefaultMessage: '%{userName} from %{organisationName} invites you to join OnceForAll platform again in order to facilitate management of your documents.\nAs their subcontractor, you will give %{userName} access to your documents that are on the OnceForAll platform.\nGiven you have already used our platform before all you need to do is to click on the button below then select your new subscription.',
      resendSuccess: '%{name} has been invited again!',
      title: 'Invite a subcontractor'
    },
    mySubcontractors: 'Subcontractors',
    projects: 'Projects',
    reinvite: {
      action: 'Invite again',
      text: 'In order for him to update his documents, invite him to join the OnceForAll network again by clicking on the button above.',
      title: 'This subcontractor is no longer active on the platform',
      tooltip: 'Invite this subcontractor to join OnceForAll again'
    },
    reminders: 'Reminders',
    search: {
      notFound: 'No subcontractor found'
    }
  },
  subscription: {
    collector: 'Collector',
    collector_and_depositor: 'Collector & depositor',
    help: {
      firstPart: 'You will find on ',
      link: 'this page',
      secondPart: ' more details on how to calculate the number of clients.'
    },
    nbClients: 'You are sharing your documents with __s%{count}__s clients.',
    noResult: "You need to contact your manager to know about your subscription's details",
    remainingNominativeProjects: '__s%{count}__s nominative project credits left',
    remainingStandardProjects: '__s%{count}__s standard project credits left',
    remainingUserAccounts: '__s%{count}__s users left',
    title: 'Current plan',
    validUntil: 'Offer valid until __s%{date}__s'
  },
  subscriptions: {
    plans: {
      actualPlan: 'CURRENT PLAN',
      clientOrganisations: 'For clients',
      collectDocuments: 'TO COLLECT DOCUMENTS',
      currency: {
        EUR: '€'
      },
      customerServiceMessage: 'For further information, please contact our sales department.',
      fee: '* Setup fee for the first year: %{price}',
      fee_0: 'No setup fee',
      free: 'Free',
      offer: 'Offer',
      option: 'Options',
      or: ' ',
      pricePeriod: {
        month: '__c%{count}__c / month exc. tax',
        none: '__c%{count}__c exc. tax',
        year: '__c%{count}__c / year exc. tax'
      },
      seeMore: 'See more',
      services: {
        de_cie_registration_purchase_v1: 'Purchase of your HR-Auszug each year',
        de_document_auth_v1: 'Verification and authentication of your documents',
        de_illimited_hotline_v1: 'Free and illimited hotline',
        de_included_clients_v1: 'My documents accessible to a maximum of %{count} clients',
        de_online_dossier_v1: '__sCompliance__s: Online management of your documents. Documents upload, 15-years archival, alerts, notifications and electronic signature',
        de_unlimited_clients_v1: 'My documents accessible for all my clients',
        fr_document_auth_v1: 'Verification and authentication of your documents',
        fr_illimited_hotline_v2: 'Free and illimited hotline',
        fr_included_broadcasting_mandate_v1: '__sDocuments synchronization with partner online platforms:__s e-Attestations, MyProcurement, Provigis, AWS',
        fr_included_collection_mandate_v1: '__sCollection mandate:__s Collection of your documents from agencies and authorities concerned by our team',
        fr_included_onceforall_platforms_v1: 'Documents synchronization with Once for All platforms : Actradis, Déclarations Légales, Hiveo',
        fr_kbis_purchase_v1: 'Purchase of your company registration 4 times a year',
        fr_limited_clients_v1: 'My documents accessible for up to __s%{count} clients maximum__s',
        fr_online_dossier_v1: '__sCompliance__s: Online management of your documents. Documents upload, 15-years archival, alerts, notifications and electronic signature',
        fr_unlimited_clients_v1: 'My documents accessible for all my clients',
        fr_free_bdr: '__sBâtisseur de Relations__s : Access to new public and private business opportunities, referencing and visibility on our network',
        it_document_auth_v1: 'Verification and authentication of your documents',
        it_illimited_hotline_v1: 'Free and illimited hotline',
        it_online_dossier_v1: '__sCompliance__s: Online management of your documents. Documents upload, 15-years archival, alerts, notifications and electronic signature',
        it_unlimited_clients_v1: 'My documents accessible for all my clients'
      },
      shareDocuments: 'TO SHARE MY DOCUMENTS',
      smallOrganisations: 'For small companies up to %{count} employees',
      subscribe: 'Subscribe',
      title: {
        de_basic_1y_v1: 'Basic',
        de_oncefor2_1y_v1: 'OnceFor2',
        de_onceforall_1y_v1: 'OnceForAll',
        fr_collector_sme_1y_v1: 'Collectant PME',
        fr_essential_v1: 'ESSENTIEL',
        fr_experience_v1: 'EXPÉRIENCE',
        fr_horizon_v1: 'HORIZON',
        fr_liberty_v1: 'LIBERTÉ',
        fr_essentialbdr: 'BUSINESS ESSENTIEL',
        fr_experiencebdr: 'BUSINESS EXPÉRIENCE',
        fr_horizonbdr: 'BUSINESS HORIZON',
        fr_libertybdr: 'BUSINESS LIBERTÉ',
        fr_onceforeignbdr: 'BUSINESS ONCE FOREIGN',
        fr_oncefor2_1y: 'ONCEFOR2',
        fr_onceforall_1y: 'ONCEFORALL',
        fr_onceforeign_1y: 'Once Foreign',
        fr_onceforever_1y: 'ONCEFOREVER',
        fr_onceformore_1y: 'ONCEFORMORE',
        it_basiccollector_V1: 'Basic',
        it_onceforall_1y: 'OnceForAll',
        it_onceforeign_1y: 'OnceForeign'
      },
      unit: {
        project: ' / project',
        user: ' / user'
      }
    },
    questions: {
      shareCompliance: {
        title: 'Do you wish to share your compliance requirements?',
        response: {
          yes: 'Yes',
          no: 'No'
        }
      },
      nbOfClients: {
        title: 'To how many clients?',
        response: {
          info: 'Select the number of clients',
          twoClients: 'Up to 2 Clients',
          twentyClients: 'Up to 20 Clients',
          fiftyClients: 'Up to 50 Clients',
          moreThanFiftyClients: '51 Clients and more'
        }
      }
    },
    title: 'Offers available for your organisation'
  },
  textsToValidate: {
    accept: {
      privacyPolicy_1: 'I have read and accept the ',
      privacyPolicy_2: 'Privacy Policy',
      required: '.*',
      termsAndConditions_1: 'I have read and accept the ',
      termsAndConditions_2: 'General Terms and Conditions ',
      termsAndConditions_3: 'and the ',
      termsAndConditions_4: 'Terms and Conditions of Use'
    },
    button: 'Accept',
    privacyPolicy: 'Privacy policy',
    subtext: 'We remain at your disposal for any clarification.',
    termsAndConditions: 'General terms and conditions',
    termsOfUse: 'Terms and conditions of use',
    text: 'We have decided to split such information in the 2 following documents, in order to facilitate reading and understanding:',
    title: 'Your platform is changing, as well as the Terms and Conditions.',
    tooltip: 'Click to open this text in a new tab'
  },
  uploadImage: {
    errorTypeMessage: 'The format of your image is not correct'
  },
  uploadLogo: {
    dragDropHere: 'Drag and drop here your logo (png, jpg, jpeg)',
    title: "Organisation's logo",
    uploadSuccess: 'Your logo is successfully updated'
  },
  user: {
    account: 'My account',
    actions: {
      untieUser: 'Untie %{firstname} %{lastname}'
    },
    add: 'Add a user',
    canNotUpdateProfile: 'To change your profile, please ',
    canNotUpdateProfileLinkText: 'contact customer service.',
    changeEmailAddress: 'Change your email address',
    changeEmailButton: 'Change email address',
    deactivatedUser: 'The user %{firstname} %{lastname} has been deactivated',
    domainNameAutomaticTieUser: 'Users whose email adress is like __s%{domainName}__s can have automatic access to this organisation with the role __sExplorer__s.',
    email: 'Email',
    emailChanged: 'A confirmation email has been sent to %{newEmail}',
    emailConfirmation: 'Confirm email',
    firstName: 'First name',
    formTitle: 'Sign up on OnceForAll',
    invite: {
      alreadyInvited: 'This user is already invited',
      alreadyPartOfOrganisation: 'This user is already part of your organisation!',
      alreadySelected: 'This user is already selected',
      button: 'Invite user',
      deactivatedUser: 'This user is deactivated',
      defaultMessage: 'You have been invited by %{userName} to join %{organisationName} on OnceForAll platform by clicking on the following link:',
      defaultUserMessage: 'You have been invited by %{userName} of %{invitingOrganisationName} (%{invitingOrganisationRegistrationNumber}) to join %{invitedOrganisationName} (%{invitedOrganisationRegistrationNumber}) on OnceForAll platform by clicking on the following link:',
      orgaDeactivated: 'You cannot invite a user into a deactivated organisation',
      orgaNonDepositor: 'You cannot invite a user into an organisation which is no longer depositor',
      panelTitle: 'Invite a user in this organisation',
      self: 'You cannot add yourself',
      successMessage: 'You have invited %{count} users to join your users list!',
      successMessage_1: 'You have invited %{name} to join your users list!',
      successfullyInvitedUserToRelationship: 'You have invited %{name} to join the organisation %{organisationName}',
      title: 'Invite a new user for your organisation',
      userAlreadyTiedToOrganisation: 'This user is already part of this organisation'
    },
    language: 'Language',
    lastName: 'Last name',
    manageProject: 'Project management',
    maxUsersReached: 'Max users is reached!',
    missingSubscription: 'You cannot perform this action because there is no subscription for this organisation.',
    mobilePhoneNumber: 'Mobile number',
    myProfile: 'Profile',
    notSelectedWarning: 'You have to select at least 1 user',
    options: {
      COLLECTOR_PERIODIC_PROJECT_REPORT: 'I accept to receive by email the project overview report',
      SUGGESTION_DISPLAY: 'I accept to see a list of clients I might want to share my dossier',
      title: 'Options'
    },
    password: 'Password',
    passwordConfirmation: 'Confirm password',
    phoneNumber: 'Phone number',
    position: 'Position',
    registrationDate: 'Registration date',
    role: 'Role',
    roles: {
      CONSULTANT: 'Consultant',
      EXPLORER: 'Explorer',
      INVITING: 'Relation manager',
      MANAGER: 'Account manager'
    },
    securePasswordPolicy: {
      atLeast1Digit: 'At least 1 digit',
      atLeast1Lowercase: 'At least 1 lowercase',
      atLeast1Uppercase: 'At least 1 uppercase',
      atLeast8Characters: 'At least 8 characters',
      tooltip: 'Use at least 8 characters with at least 1 lowercase, 1 uppercase and 1 digit'
    },
    sign: 'E-sign',
    signWaitingText: 'Please wait, you will be redirected to our electronic signature provider...',
    title: 'Add a user for your organisation',
    updateButton: 'Confirm'
  },
  vitrine: {
    access: {
      confirm: 'Create my references list',
      text1: '__sDigitalisation of the construction references list__s',
      text2: 'Find out how to create and upload your construction references list from the OnceForAll platform.',
      text3: 'Via our online interface, you can enter all the information concerning your references, add photos and export a list in the most appropriate format.',
      text4: '__sSave time when responding to calls for tenders__s thanks to this feature, which allows you to __sgather your references on a single platform and to promote your know-how and achievements.__s',
      text5: 'To find out more, click here',
      text6: 'By clicking on "Create my references list", your user account and your companies on OnceForAll platform will be automatically synced.'
    },
    discover: {
      cancel: 'I do not want to create my reference list',
      cta: 'TRY NOW',
      text1: '__sNEW: Create and download your References list in a few clicks__s',
      text2: 'Gather your references - Promote your know-how and achievements - Save time'
    }
  }
};
